export const STUDY_METHODS = {
  FAVORITE: 'favorite',
  SUBMIT: 'submit',
  MY_FAVORITE: 'myFavorite',
  MY_SUBMIT: 'mySubmit',
};
